import React from "react";
import "./FlightTimeline.css";

export default function FlightTimeline({ segment }) {
  if (!segment) return null;
  const stops = Number(segment.stops) || 0;
  const stopTone =
    stops === 0 ? "direct" : stops === 1 ? "one" : "multi";

  return (
    <div className="fe2-tl">
      <div className="fe2-tl__row">
        <div className="fe2-tl__end">
          <time className="fe2-tl__time fe2-ltr">{segment.depTime}</time>
          <span className="fe2-tl__iata fe2-ltr">{segment.depIata}</span>
        </div>

        <div className="fe2-tl__mid">
          <span className="fe2-tl__duration fe2-ltr">{segment.duration}</span>
          <span className="fe2-tl__line" aria-hidden />
          <span className={`fe2-tl__stops fe2-tl__stops--${stopTone}`}>
            {segment.stopsLabel}
          </span>
        </div>

        <div className="fe2-tl__end fe2-tl__end--arr">
          <time className="fe2-tl__time fe2-ltr">{segment.arrTime}</time>
          <span className="fe2-tl__iata fe2-ltr">{segment.arrIata}</span>
        </div>
      </div>
      <div className="fe2-tl__meta">
        <span className="fe2-ltr">{segment.date}</span>
        <span aria-hidden>·</span>
        <span className="fe2-ltr">{segment.flightNumber}</span>
        {segment.connection ? (
          <>
            <span aria-hidden>·</span>
            <span>{segment.connection}</span>
          </>
        ) : null}
      </div>
      <IncludedLegBags baggage={segment.includedBaggage} />
    </div>
  );
}

function IncludedLegBags({ baggage }) {
  if (!baggage?.carryOn && !baggage?.checked) return null;
  return (
    <div className="fe2-tl__bags">
      {baggage.carryOn ? (
        <span className="fe2-tl__bag fe2-tl__bag--trolley">
          <TrolleyIcon />
          <span>{baggage.carryOnLabel || "טרולי"}</span>
        </span>
      ) : null}
      {baggage.checked ? (
        <span className="fe2-tl__bag fe2-tl__bag--checked">
          <SuitcaseIcon />
          <span>{baggage.checkedLabel || "מזוודה"}</span>
        </span>
      ) : null}
    </div>
  );
}

function TrolleyIcon() {
  return (
    <svg className="fe2-tl__bag-icon" viewBox="0 0 16 16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6 2.2c0-.7.5-1.2 1.2-1.2h1.6c.7 0 1.2.5 1.2 1.2V4H6V2.2zM4.2 4h7.6c.7 0 1.2.5 1.2 1.2v6.2c0 .7-.5 1.2-1.2 1.2H4.2c-.7 0-1.2-.5-1.2-1.2V5.2C3 4.5 3.5 4 4.2 4zm.3 9.2a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2zm7 0a1.1 1.1 0 1 0 0 2.2 1.1 1.1 0 0 0 0-2.2z"
      />
    </svg>
  );
}

function SuitcaseIcon() {
  return (
    <svg className="fe2-tl__bag-icon" viewBox="0 0 16 16" aria-hidden="true">
      <path
        fill="currentColor"
        d="M5.5 3.2V2.4c0-.7.6-1.2 1.3-1.2h2.4c.7 0 1.3.5 1.3 1.2v.8h1.3c.7 0 1.2.5 1.2 1.2v7.2c0 .7-.5 1.2-1.2 1.2h-.4v.6a.8.8 0 1 1-1.6 0v-.6H6.2v.6a.8.8 0 1 1-1.6 0v-.6h-.4c-.7 0-1.2-.5-1.2-1.2V4.4c0-.7.5-1.2 1.2-1.2h1.3zm1.6-.8v.8h1.8v-.8H7.1z"
      />
    </svg>
  );
}
